export default __webpack_public_path__ + "static/media/white-right.80757b0c.svg";